import { useCallback, useState } from 'react';
import { downloadData } from '../utils/downloadData';
import { replaceNonAlphanumeric } from '../utils/replaceNonAlphanumeric';
import useReportConfig, { VerifiedReportConfig } from './useReportConfig';
import { ReportConfig } from '../types/aemDataModels';
import useErrorMapping from './useErrorMapping';

const useDownloadReport = ({
  action,
  reportConfig,
}: {
  action: ((param: string, reportConfig: VerifiedReportConfig) => Promise<string | undefined>) | null;
  reportConfig?: ReportConfig;
}) => {
  const [downloadingReport, setDownloadingReport] = useState(false);
  const verifiedReportConfig = useReportConfig(reportConfig);
  const { triggerSnackbarError } = useErrorMapping();

  const wrappedDownloadReport = useCallback(async (param?: string) => {
    if (!verifiedReportConfig) {
      return;
    }

    try {
      setDownloadingReport(true);
      const blob = await action?.(param || '', verifiedReportConfig);

      downloadData(blob || '', `${replaceNonAlphanumeric(verifiedReportConfig?.nameFormat || '')}.csv`, {
        bom: true,
        contentType: 'text/csv;charset=utf-8;',
      });
    } catch (reportError: any) {
      triggerSnackbarError(reportError);
    } finally {
      setDownloadingReport(false);
    }
  }, []);

  return { wrappedDownloadReport, downloadingReport };
};

export default useDownloadReport;
